/*
* 预测色值
*/
const forecastColors = [{
  desc: '上升',
  color: '#FF4B4B',
  iconClass: 'ic-trianglearr-up-s'
}, {
  desc: '下降',
  color: '#2AB352',
  iconClass: 'ic-trianglearr-down-s'
}, {
  desc: '持平',
  color: '#F47A23',
  iconClass: 'ic-par-s'
}];

/*
* 热门区域色值
*/
const hotColors = [{
  desc: '商圈',
  color: '#996C43',
  bgColor: 'rgba(242,134,34,0.08)'
}, {
  desc: '交通枢纽',
  color: '#4970BF',
  bgColor: 'rgba(26,102,255,0.08)'
}, {
  desc: '景区',
  color: '#368A89',
  bgColor: 'rgba(15,153,144,0.08)'
}];

function getForecastColor(heat) {
  return forecastColors.filter((item) => item.desc === heat);
}

// 商圈1 交通枢纽2  景区3
function getHotColor(value) {
  if (value === 1) {
    return hotColors[0];
  } if (value === 2) {
    return hotColors[1];
  } if (value === 3) {
    return hotColors[2];
  }
}

// 热门目的地热度趋势
function getHotAoiColor(heat) {
  if (heat > 0) {
    return forecastColors[0];
  } if (heat < 0) {
    return forecastColors[1];
  }
  return forecastColors[2];
}

export default {
  getForecastColor,
  getHotColor,
  getHotAoiColor
};
